/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useMemo, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../util/snackBar'
import {ratioSalesDetailSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {useGuests} from '../../../hooks/useGuests'
import {useModules} from '../../../hooks/useModules'
import {useRooms} from '../../../hooks/useRooms'
import {RatioSalesDetailColumn, RatioSalesDetailDto} from '../../../models/reports.model'
import {
  getRatioSalesDetailCSVService,
  getRatioSalesDetailExcelService,
  getRatioSalesDetailPDFService,
  getRatioSalesDetailService,
} from '../../../services/ratio.service'

const TableSalesDetail: FC = () => {
  const {
    setPagination,
    pagination,
    setData,
    data,
    loading,
    setLoading,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()
  const methods = useForm<RatioSalesDetailDto>({
    resolver: yupResolver(ratioSalesDetailSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      CampamentoId: '',
      SiteId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [enterprises, setEnterprises] = useState<SelectOption[]>([])
  const [guests, setGuests] = useState<SelectOption[]>([])
  const [typeModules, setTypeModules] = useState<SelectOption[]>([])
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)
  const [typeRooms, setTypeRooms] = useState<SelectOption[]>([])

  const {searchValues} = useKhipu()
  const {getGuests} = useGuests()
  const {getTypeRooms} = useRooms()
  const {getTypeModules} = useModules()
  const {getCompanies, getClients, getSites, getCamps, getEnterprises} = useCentralServices()
  ///
  ///

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
      await getGuestsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  const getGuestsFn = async (siteId: string | null) => {
    const data = await getGuests({pageNumber: 1, size: 2000, SiteId: siteId})
    setGuests(data)
  }

  const getEnterprisesFn = async () => {
    const data = await getEnterprises({isCombo: true}, 1)
    setEnterprises(data)
  }
  const getTypeModulesFn = async () => {
    const data = await getTypeModules()
    setTypeModules(data)
  }

  const getTypeRoomsFn = async () => {
    const data = await getTypeRooms()
    setTypeRooms(data)
  }

  useEffect(() => {
    getCompaniesFn()
    getEnterprisesFn()
    getTypeModulesFn()
    getTypeRoomsFn()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRatios = async () => {
    try {
      setLoading(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const obj2 = {...searchValues}
      for (var clave2 in obj2) {
        if (obj2.hasOwnProperty(clave2)) {
          if (obj2[clave2] === '') {
            obj2[clave2] = null
          }
        }
      }
      const formValue = {
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
        ...obj2,
      }
      const {data: response} = await getRatioSalesDetailService(formValue)
      if (!response.error) {
        let totalItem: RatioSalesDetailColumn = {
          NroReserva: 'TOTAL',
          CostoFijo: response.TotalCostoFijo,
          CostoVariable: response.TotalCostoVariable,
          CostoTotal: response.TotalCostoTotal,
        }
        let arrCompany = response.data.length > 0 ? [...response.data, totalItem] : response.data
        setData(arrCompany)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onSubmit = (dataForm: any) => {
    if (pagination.currentPage === 1) {
      getRatios()
    } else {
      setPagination({...pagination, currentPage: 1, perPage: 10})
    }
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaIni', value)
    setError('FechaIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaFin', value)
    setError('FechaFin', {})
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    getGuestsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
  }

  const handleClear = () => {
    reset()
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    setData([])
    setPagination({...pagination, totalResults: 0})
  }

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const obj2 = {...searchValues}
      for (var clave2 in obj2) {
        if (obj2.hasOwnProperty(clave2)) {
          if (obj2[clave2] === '') {
            obj2[clave2] = null
          }
        }
      }
      const formValue = {
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
        ...obj2,
      }
      const response = await getRatioSalesDetailExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Detalle de Ventas-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const obj2 = {...searchValues}
      for (var clave2 in obj2) {
        if (obj2.hasOwnProperty(clave2)) {
          if (obj2[clave2] === '') {
            obj2[clave2] = null
          }
        }
      }
      const formValue = {
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
        ...obj2,
      }
      const response = await getRatioSalesDetailCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Detalle de Ventas-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const obj2 = {...searchValues}
      for (var clave2 in obj2) {
        if (obj2.hasOwnProperty(clave2)) {
          if (obj2[clave2] === '') {
            obj2[clave2] = null
          }
        }
      }
      const formValue = {
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj,
        ...obj2,
      }
      const response = await getRatioSalesDetailPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Detalle de Ventas-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getRatios()
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getRatios()
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    getRatios()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<RatioSalesDetailColumn>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de reserva' name='NroReserva' searcheable />
        ),
        accessor: 'NroReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa'
            name='HuespedEmpresaId'
            selecteable
            data={enterprises}
          />
        ),
        accessor: 'HuespedEmpresaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            // name='CampamentoId'
            // selecteable
            // data={[]}
          />
        ),
        accessor: 'ClienteNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            // name='CampamentoId'
            // selecteable
            // data={[]}
          />
        ),
        accessor: 'CampamentoNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de Estadia' />,
        accessor: 'FechaEstadia',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc.' />,
        accessor: 'HuespedTipoDoc',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc.' name='HuespedNroDoc' searcheable />
        ),
        accessor: 'HuespedNroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedId'
            selecteable
            data={guests}
          />
        ),
        accessor: 'HuespedNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='ModuloCodigo'
            searcheable
          />
        ),
        accessor: 'ModuloCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Módulo'
            name='TipoModuloId'
            selecteable
            data={typeModules}
          />
        ),
        accessor: 'TipoModuloNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitacion'
            name='HabitacionCodigo'
            searcheable
          />
        ),
        accessor: 'HabitacionCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Habitación'
            name='TipoHabitacionId'
            selecteable
            data={typeRooms}
          />
        ),
        accessor: 'TipoHabitacionNombre',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CamaCodigo'
            searcheable
          />
        ),
        accessor: 'CamaCodigo',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Costo Fijo'
            // name='CostoFijo'
            // searcheable
          />
        ),
        accessor: 'CostoFijo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Costo Variable'
            // name='CostoVariable'
            // searcheable
          />
        ),
        accessor: 'CostoVariable',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Costo Total'
            // name='CostoTotal'
            // searcheable
          />
        ),
        accessor: 'CostoTotal',
      },
    ],
    [guests, enterprises, typeRooms, typeModules],
  )

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='SiteId'
                    data={site}
                    errors={errors}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select control={control} name='CampamentoId' data={camp} errors={errors} />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Inicial:</label>
                  <InputDate
                    name='FechaIni'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateIni}
                    // maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Final:</label>
                  <InputDate
                    name='FechaFin'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateFin}
                    // maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const RatiosSalesDetail = () => {
  return (
    <KTableProvider>
      <div>
        <TableSalesDetail />
        <SnackbarProvider />
      </div>
    </KTableProvider>
  )
}

export {RatiosSalesDetail}
